<template>
  <div class="content">
    <card class="text-left">
      <template slot="header">
        <div class="d-flex justify-content-between align-items-start">
          <h4 class="card-title">리워드 위젯 관리</h4>
          <base-button @click="goWidgetForm()" type="primary" size="sm">+ 위젯 등록</base-button>
        </div>
      </template>
      <div class="row align-items-center">
        <div class="col-sm-4">
          <el-select v-model="unitId" placeholder="아티스트 선택" @change="getRewards" style="width: 100%">
            <el-option label="전체" :value="null" />
            <el-option v-for="unit in units" :key="unit.value" :label="unit.label" :value="unit.value" />
          </el-select>
        </div>
      </div>
    </card>

    <draggable class="row" v-model="widgets" group="people" @start="drag = true" @end="drag = false">
      <div class="col-sm-3 mb-3" v-for="item in widgets" :key="item.id">
        <reward-item :item="item" @click="goWidgetForm(item.id)" />
      </div>
    </draggable>
  </div>
</template>
<script>
import { BaseButton, Card } from "@/components/index";
import draggable from "vuedraggable";
import RewardItem from "@/pages/Poll/RewardItem.vue";

export default {
  components: {
    Card,
    BaseButton,
    draggable,
    RewardItem,
  },
  async created() {
    await Promise.all([this.getUnits(), this.getRewards()]);
  },
  data() {
    return {
      unitId: null,
      units: [],
      drag: false,
      widgets: [],
    };
  },
  methods: {
    async getUnits() {
      return this.$axios.get("/artistUnit?isFilter=1").then((res) => {
        this.units = (res.data.data ?? []).map((item) => ({
          label: item.blipName,
          value: item.unitId,
        }));
      });
    },
    async getRewards() {
      const params = {};
      if (this.unitId) params.unitId = this.unitId;
      return this.$axios.get("/rewards", { params }).then((res) => {
        this.widgets = (res.data.data?.items ?? []).map((item) => ({
          ...item,
          imageFileUrl: item.imageFileId ? window.Endpoints.imageServerUrl + item.imageFileId : null,
        }));
      });
    },
    async setWidgetOrder() {
      const widgets = [];
      this.widgets.forEach((widget, order) => {
        widgets.push({ id: widget.id, order, unitId: this.unitId });
      });
      return this.$axios.put("/rewardWidget/order", { widgets }).then(() => {
        window.Toast.success("위젯의 노출순서가 변경되었습니다");
        this.getRewards();
      });
    },
    goWidgetForm(id) {
      if (id) {
        this.$router.push(`/poll/rewardForm?rewardId=${id}`);
      } else {
        this.$router.push(`/poll/rewardForm`);
      }
    },
  },
};
</script>
<style></style>
